module.exports = __webpack_public_path__ + "static/media/KusalFonseka.d22dbc32.jpeg";